import React from 'react';
import s from './s.module.less';

type Props = {
    level?: number;
    text?: string;
};

const AnswerLabel = (props: Props) => {
    const { level, text } = props;
    const BgColors: string[] = ['#F3F4F6', '#F3F4F6', '#DBEAFE', '#FEF3C7', '#FEE2E2', '#FCA5A5'];
    const TextColors: string[] = ['#1F2937', '#1F2937', '#1E40AF', '#92400E', '#991B1B', '#991B1B'];
    let _level = level;
    if (!_level || _level < 0) {
        _level = 0;
    } else if (_level > 5) {
        _level = 5;
    }
    const textColor = TextColors[_level];
    const bgColor = BgColors[_level];
    return (
        <div className={s.label} style={{ backgroundColor: bgColor, color: textColor }}>
            {text}
        </div>
    );
};

export default AnswerLabel;
